<template>
  <div>
    <v-simple-table class="pa-5">
      <template v-slot:top>
        <v-row>
          <v-spacer />
          <v-progress-circular
            v-if="loading"
            class="mt-6 mr-2"
            indeterminate
            color="primary"
          />

          <v-col cols="2">
            <v-menu
              v-model="showPickerFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date_from"
                  label="Od (dátum)"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_from"
                no-title
                first-day-of-week="1"
                @input="showPickerFrom = false"
              />
            </v-menu>
          </v-col>
          <v-col cols="2">
            <v-menu
              v-model="showPickerTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date_to"
                  label="Do (dátum)"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_to"
                no-title
                first-day-of-week="1"
                @input="showPickerTo = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </template>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Ústav
            </th>
            <th class="text-left">
              Celkový počet formulárov
            </th>
            <th class="text-left">
              Z toho počet uzavretých CRA-CR formulárov
            </th>
            <th class="text-left">
              Z toho počet neuzavretých CRA-CR formulárov
            </th>
            <th class="text-left">
              Z toho počet uzavretých CRA-RU formulárov
            </th>
            <th class="text-left">
              Z toho počet neuzavretých CRA-RU formulárov
            </th>
            <th class="text-left">
              CRA-CR Riziko recidívy trestnej činnosti nízke
            </th>
            <th class="text-left">
              CRA-CR Riziko recidívy trestnej činnosti stredné
            </th>
            <th class="text-left">
              CRA-CR Riziko recidívy trestnej činnosti vysoké
            </th>
            <th class="text-left">
              CRA-RU Riziko recidívy trestnej činnosti nízke
            </th>
            <th class="text-left">
              CRA-RU Riziko recidívy trestnej činnosti stredné
            </th>
            <th class="text-left">
              CRA-RU Riziko recidívy trestnej činnosti vysoké
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item.ustav"
          >
            <td>{{ item.ustav }}</td>
            <td>{{ item.celkovo }}</td>
            <td>{{ item.uzavretych_cr }}</td>
            <td>{{ item.neuzavretych_cr }}</td>
            <td>{{ item.uzavretych_ru }}</td>
            <td>{{ item.neuzavretych_ru }}</td>
            <td>{{ item.nizke_riziko_cr }}</td>
            <td>{{ item.stredne_riziko_cr }}</td>
            <td>{{ item.vysoke_riziko_cr }}</td>
            <td>{{ item.nizke_riziko_ru }}</td>
            <td>{{ item.stredne_riziko_ru }}</td>
            <td>{{ item.vysoke_riziko_ru }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>


<script>
import { APIService } from "@/http/APIService.js";
import moment from "moment";

const apiService = new APIService();

export default {
  data: () => ({
    loading: false,
    items: [],
    date_from: "2019-10-01",
    date_to: moment().format("YYYY-MM-DD"),

    showPickerFrom: false,
    showPickerTo: false
  }),

  watch: {
    date_from(val) {
      val && this.getStatistics();
    },
    date_to(val) {
      val && this.getStatistics();
    }
  },

  created() {
    this.getStatistics();
  },

  methods: {
    getStatistics() {
      this.loading = true;
      apiService.getStatistics(this.date_from, this.date_to).then(response => {
        this.items = response;
        this.loading = false;
      });
    }
  }
};
</script>